module.exports = __webpack_public_path__ + "img/file-117.e49f14bc.png";